import React from 'react';

import {
  Button,
  ButtonVariant,
  TabHeaderSlider,
  TabHeaderSliderHandler,
  TabSelector,
} from '@ael/shared-components-library';
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons';

type InteractiveWidgetComponentProps = {
  tabs: Array<string>;
  currentTabIndex: number;
  setCurrentTabNumber: (tabIndex: number) => void;
  displayTabSlider?: boolean;
};

const DEAFULT_STUDENT_TABS_RESPONSIVE_OBJECTS = [
  {
    breakpoint: 350,
    settings: {
      slidesToShow: 1,
    },
  },
  {
    breakpoint: 500,
    settings: {
      slidesToShow: 3,
    },
  },
];

export const InteractiveWidgetHeader = (props: InteractiveWidgetComponentProps) => {
  const [isAnimating, setIsAnimating] = React.useState(false);
  const sliderRef = React.useRef<TabHeaderSliderHandler>(null);

  const maxTabNumber = props.tabs.length - 1;

  const moveSlider = (index: number) => {
    props.setCurrentTabNumber(index);
    sliderRef.current?.slideTo(index);
  };

  const nextTabClick = () => {
    if (!isAnimating) {
      moveSlider(Math.min(maxTabNumber, props.currentTabIndex + 1));
    }
  };

  const prevTabClick = () => {
    if (!isAnimating) {
      moveSlider(Math.max(0, props.currentTabIndex - 1));
    }
  };

  return (
    <div className="uno-flex uno-items-center uno-gap-2 uno-mb-2 uno-relative uno-min-w-0">
      <Button
        variant={ButtonVariant.SECONDARY}
        icon={faChevronLeft}
        onClick={prevTabClick}
        disabled={props.currentTabIndex === 0}
      />

      <Button
        variant={ButtonVariant.SECONDARY}
        icon={faChevronRight}
        onClick={nextTabClick}
        disabled={props.currentTabIndex === maxTabNumber}
      />

      <Button variant={ButtonVariant.SECONDARY}>{`${props.currentTabIndex + 1} / ${maxTabNumber + 1}`}</Button>

      {props.displayTabSlider && (
        <div className="uno-min-w-0 uno-w-full">
          <TabHeaderSlider
            ref={sliderRef}
            maxVisibleTabs={5}
            onIndexChanged={(index, visibleSlides) => {
              if (visibleSlides === 1) {
                moveSlider(index);
              }
            }}
            tabs={props.tabs.map((tab, i) => (
              <TabSelector.Item
                active={props.currentTabIndex === i}
                onClick={() => {
                  moveSlider(i);
                }}
                key={i}
                content={{ label: tab }}
              />
            ))}
            onAnimationChange={setIsAnimating}
            responsive={DEAFULT_STUDENT_TABS_RESPONSIVE_OBJECTS}
          />
        </div>
      )}
    </div>
  );
};
